import { useState } from 'react'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import {
  DEFAULT_VIDEO_CAPTION_STYLE,
  resolveVideoCaptionStyle,
  VIDEO_CAPTION_STYLE_OPTIONS,
  type VideoCaptionStyle,
} from '../videoVoiceoverCaptionsConstants'
import { VIDEO_CAPTION_PREVIEW_URLS } from '../videoVoiceoverCaptionsUtils'
import { VideoCaptionStyleCard } from './VideoCaptionStyleCard'
import Styles from './VideoCaptionStyleModal.module.scss'

export type VideoCaptionStyleModalProps = {
  selectedStyle: string
  onConfirm: (style: VideoCaptionStyle) => void
  confirmLabel?: string
}

export const VideoCaptionStyleModal = ({
  selectedStyle,
  onConfirm,
  confirmLabel = 'Save changes',
}: VideoCaptionStyleModalProps) => {
  const { closeModal } = useModals()
  const [pendingStyle, setPendingStyle] = useState<VideoCaptionStyle>(resolveVideoCaptionStyle(selectedStyle))

  const handleSave = () => {
    onConfirm(pendingStyle || DEFAULT_VIDEO_CAPTION_STYLE)
    closeModal()
  }

  return (
    <Modal.Root size="lg" blaze onPressOutside={closeModal} data-testid="video-caption-style-modal">
      <Modal.Header title="Caption style" onClose={closeModal} />
      <Modal.Content className={Styles.content}>
        <div className={Styles.grid}>
          {VIDEO_CAPTION_STYLE_OPTIONS.map((option) => (
            <VideoCaptionStyleCard
              key={option.key}
              label={option.label}
              previewUrl={VIDEO_CAPTION_PREVIEW_URLS[option.key]}
              isSelected={pendingStyle === option.key}
              onSelect={() => setPendingStyle(option.key)}
            />
          ))}
        </div>
      </Modal.Content>
      <Modal.Footer sticky className={Styles.footer}>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={closeModal}>
            Close
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button size="lg" onPress={handleSave}>
            {confirmLabel}
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
